<template>
    <button class="btn" @click.prevent="showModal">{{word.send_message}}</button>
</template>

<script>
    import Swal from "sweetalert2";

    export default {
        name: "create-chat",

        components: {
            Swal
        },

        props: {
            user: {
                required: true
            }
        },

        data() {
            return {
                word: window.word,
                text: window.text,
            }
        },

        methods: {
            showModal() {
                Bus.$emit('showCreateChatModal', {user: this.user});
            }
        }
    }
</script>
